/* Supplement only rendered collection products before Shopify's form lookups. */
(() => {
  'use strict';
  if (document.currentScript?.getAttribute('data-page-type') !== 'collection') return;
  if (window.__beleaevCollectionAnalyticsInstalled) return;
  window.__beleaevCollectionAnalyticsInstalled = true;

  const selector = 'script[type="application/json"][data-beleaev-analytics-product]';
  const consumed = new WeakSet();
  const parsed = new WeakMap();
  const pending = new Set();
  const validId = (value) => (typeof value === 'number' || typeof value === 'string') && Number.isSafeInteger(Number(value)) && Number(value) > 0 && /^\d+$/.test(String(value));
  const isText = (value) => typeof value === 'string';

  /** @returns {object|null} Public catalogue fields only; reject malformed markers. */
  function readProduct(marker) {
    if (parsed.has(marker)) return parsed.get(marker);
    let product;
    try {
      product = JSON.parse(marker.textContent);
    } catch {
      console.warn('[beleaev_collection_analytics] Invalid product JSON marker; skipped.');
      return null;
    }
    if (!product || !validId(product.id) || product.gid !== `gid://shopify/Product/${product.id}` ||
        product.remote !== false || ![product.vendor, product.type, product.handle].every(isText) ||
        !Array.isArray(product.variants) || !product.variants.length ||
        !product.variants.every((variant) => variant && validId(variant.id) &&
          Number.isSafeInteger(variant.price) && variant.price >= 0 && isText(variant.name) &&
          (variant.public_title === null || isText(variant.public_title)) &&
          (variant.sku === null || isText(variant.sku)))) {
      console.warn('[beleaev_collection_analytics] Invalid product metadata marker; skipped.');
      return null;
    }
    const variants = new Map();
    product.variants.forEach(({ id, price, name, public_title, sku }) => {
      if (!variants.has(String(id))) variants.set(String(id), { id, price, name, public_title, sku });
    });
    const result = {
      id: product.id, gid: product.gid, vendor: product.vendor, type: product.type,
      handle: product.handle, remote: false, variants: [...variants.values()],
    };
    parsed.set(marker, result);
    return result;
  }

  /** Add missing entries without changing existing Shopify catalogue fields. */
  function flush() {
    pending.forEach((marker) => {
      if (!marker.isConnected) pending.delete(marker);
    });
    const meta = window.ShopifyAnalytics?.meta;
    if (!meta || !Array.isArray(meta.products) ||
        (meta.page?.pageType && meta.page.pageType !== 'collection')) return;
    const existing = new Map();
    meta.products.forEach((product) => {
      if (product && validId(product.id) && !existing.has(String(product.id))) existing.set(String(product.id), product);
    });
    pending.forEach((marker) => {
      pending.delete(marker);
      if (!marker.isConnected) return;
      const addition = readProduct(marker);
      consumed.add(marker);
      if (!addition) return;
      const product = existing.get(String(addition.id));
      if (!product) {
        meta.products.push(addition);
        existing.set(String(addition.id), addition);
      } else if (Array.isArray(product.variants)) {
        const ids = new Set(product.variants.filter(Boolean).map((variant) => String(variant.id)));
        addition.variants.forEach((variant) => {
          if (!ids.has(String(variant.id))) {
            product.variants.push(variant);
            ids.add(String(variant.id));
          }
        });
      }
    });
  }

  function collect(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches?.(selector) && !consumed.has(root)) pending.add(root);
    root.querySelectorAll(selector).forEach((marker) => {
      if (!consumed.has(marker)) pending.add(marker);
    });
  }

  function collectRecords(records) {
    records.forEach((record) => record.addedNodes.forEach(collect));
  }

  const observer = new MutationObserver((records) => {
    collectRecords(records);
    if (pending.size) flush();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  collect(document);
  flush();

  // Capture also drains queued insertions when a form event fires in the same task.
  function beforeFormAnalytics() {
    collectRecords(observer.takeRecords());
    if (pending.size) flush();
  }
  document.addEventListener('change', beforeFormAnalytics, true);
  document.addEventListener('submit', beforeFormAnalytics, true);
  document.addEventListener('DOMContentLoaded', beforeFormAnalytics, { once: true });
})();
